import { cn } from "@/lib/utils";
import { AnswerMode, Choice, ChoiceType } from "@/types/questionnaries";
import { FC } from "react";
import AllRequiredChoiceList from "./all-required-choice-list";
import MultipleChoiceList from "./multiple-choice-list";
import SingleChoiceList from "./single-choice-list";

type ChoiceListProps = {
  choice: Choice;
  level?: number;
  className?: string;
  disabled?: boolean;
};

const ChoiceList: FC<ChoiceListProps> = ({
  choice,
  className,
  level = 0,
  disabled,
}) => {
  if (choice.type === ChoiceType.Composite) {
    if (choice.answerMode === AnswerMode.Multiple) {
      return (
        <MultipleChoiceList
          choice={choice}
          level={level}
          className={className}
          disabled={disabled}
        />
      );
    }

    if (choice.answerMode === AnswerMode.Single) {
      return (
        <SingleChoiceList
          choice={choice}
          level={level}
          className={className}
          disabled={disabled}
        />
      );
    }

    if (choice.answerMode === AnswerMode.AllRequired) {
      return (
        <AllRequiredChoiceList
          choice={choice}
          level={level}
          className={cn(className, "mb-2")}
          disabled={disabled}
        />
      );
    }
  }

  return null;
};

export default ChoiceList;
